import request from 'utils/request'
import { MCAXS431QueryRequest } from 'types/MCAXS431/MCAXS431QueryRequest'

export const getMCAXS431InitRequest = (data: MCAXS431QueryRequest) =>
  request({
    url: '/MCAXS431/init',
    method: 'post',
    data: data,
  })
